/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_SubmittingInputs */

const en_directory_submit_submitting = /** @type {(inputs: Directory_Submit_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting…`)
};

const zh_directory_submit_submitting = /** @type {(inputs: Directory_Submit_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交中…`)
};

/**
* | output |
* | --- |
* | "Submitting…" |
*
* @param {Directory_Submit_SubmittingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_submitting = /** @type {((inputs?: Directory_Submit_SubmittingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_SubmittingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_submitting(inputs)
	return zh_directory_submit_submitting(inputs)
});
export { directory_submit_submitting as "directory.submit.submitting" }